"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildingIndustriesRebalanced = void 0;
var Tags_1 = require("../../Tags");
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Units_1 = require("../../../Units");
var BuildingIndustriesRebalanced = (function (_super) {
    __extends(BuildingIndustriesRebalanced, _super);
    function BuildingIndustriesRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.BUILDING_INDUSTRIES_REBALANCED,
            tags: [Tags_1.Tags.BUILDING],
            cost: 5,
            productionBox: Units_1.Units.of({ energy: -1, steel: 2 }),
            metadata: {
                cardNumber: '065',
                description: 'Decrease your Energy production 1 step and increase your steel production 2 steps.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.minus().energy(1).br;
                        pb.plus().steel(2);
                    });
                }),
            },
        }) || this;
    }
    BuildingIndustriesRebalanced.prototype.canPlay = function (player) {
        return player.getProduction(Resources_1.Resources.ENERGY) >= 1;
    };
    BuildingIndustriesRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        player.addProduction(Resources_1.Resources.STEEL, 2);
        return undefined;
    };
    return BuildingIndustriesRebalanced;
}(Card_1.Card));
exports.BuildingIndustriesRebalanced = BuildingIndustriesRebalanced;
//# sourceMappingURL=BuildingIndustriesRebalanced.js.map